export default function LandingPage(){
    return (
    <div>
        <div id="hero-container">
            <div id="hero-content">
                <p id="my_intro__name">Hi, I'm Ellis</p>

                <p id="my_intro__description">I'm a Web Developer focused on delivering clean, efficient, and user-friendly solutions that meet the specific needs of each project.</p>
            </div>
        </div>
        <div id="down-arrow-container">
            <i class="fa-solid fa-arrow-down"></i>
        </div>
    </div>
       
    )
}